
import { FileText } from "lucide-react";

interface EmptyStateProps {
  message: string;
  description?: string;
}

const EmptyState = ({ message, description = "Não há registros disponíveis para exibição." }: EmptyStateProps) => (
  <div className="flex flex-col items-center justify-center py-12">
    <div className="rounded-full bg-gray-100 p-3">
      <FileText className="h-6 w-6 text-gray-500" />
    </div>
    <p className="mt-4 text-gray-700">{message}</p>
    <p className="text-sm text-gray-500">{description}</p>
  </div>
);

export default EmptyState;
